import { ErrorCode } from './ErrorCode';

export const HttpStatusCodeMapErrorCode: Record<
  number,
  ErrorCode.NotExisted | ErrorCode.Unauthorized | ErrorCode.Unknown
> = {
  404: ErrorCode.NotExisted,
  401: ErrorCode.Unauthorized,
  500: ErrorCode.Unknown,
};
